import _ from 'lodash';

import * as api from 'api';

import ModalWindow from '../ModalWindow/ModalWindow';
import Tools from '../Tools/Tools';
export const WebInterfacesType = {
	OpenRTB: 'OpenRTB',
	VAST: 'VAST',
	XHR: 'XHR',
};

class WebInterfacesDialog {
	/**
	 * @param {String} title
	 * @param {Number} webId
	 * @param {Array.<String>} activeInterfaces
	 */
	constructor(title, webId, activeInterfaces) {
		this.title = title;
		this.webId = webId;
		this.activeInterfaces = activeInterfaces;

		this.show();
	}

	show() {
		if (!this._modalWrap) {
			this._createModal();
		}

		this._modal.openByCustomEvent(this._modalWrap);
	}

	_createOptions() {
		return Object.values(WebInterfacesType).map((webInterface) => {
			const isActive = this.activeInterfaces.some((activeInterface) => activeInterface === webInterface);

			const checkBoxWrapper = Tools.createElement('label');
			const checkBox = Tools.createElement('input', {
				checked: isActive,
				name: 'activeInterfaces',
				type: 'checkbox',
				value: webInterface,
			});

			// We want to disable save button in 2 cases:
			// 1. There is no option checked (at least one interface has to be chosen)
			// 2. Checked options have not changed
			checkBox.addEventListener('change', () => {
				const options = document.querySelectorAll('#webInterfacesOptions input[name="activeInterfaces"]');

				const chosenInterfaces = Array.from(options)
					.filter((option) => option.checked)
					.map((option) => option.value);

				const haveChosenInterfacesChanged = _.isEqual(chosenInterfaces.sort(), this.activeInterfaces.sort());

				this._saveButton.disabled = chosenInterfaces.length === 0 || haveChosenInterfacesChanged;
			});

			const label = Tools.createElement('span', {
				innerText: webInterface,
			});

			Tools.appendChilds(checkBoxWrapper, checkBox, label);

			return checkBoxWrapper;
		});
	}

	_createModal() {
		this._modalWrap = Tools.createElement('div', {
			class: 'Modal Modal--default Modal--webInterfaces',
			innerHTML: '<span class="Modal-close"></span>',
		});

		this._title = Tools.createElement('h2', {
			innerText: this.title,
		});

		this._content = Tools.createElement('form', {
			id: 'webInterfacesOptions',
		});

		// creating checkboxes
		this._options = this._createOptions();
		Tools.appendChilds(this._content, ...this._options);

		const buttonsWrapper = Tools.createElement('div', {
			class: 'Modal-buttons',
		});

		this._saveButton = Tools.createElement('button', {
			class: 'Modal-submit',
			innerText: 'Uložit',
		});

		// unless user change the checked options button is disabled
		this._saveButton.disabled = true;
		Tools.appendChilds(buttonsWrapper, this._saveButton);

		// while waiting for response from server we render spinner
		this._loadingModalOverlay = Tools.createElement('div', {
			class: 'Modal-loading-overlay hidden',
			innerHTML: "<img class='Form-status-spinner' src='/app/static/img/loading.gif' alt=\"loader\" />",
		});

		this._saveButton.addEventListener('click', () => {
			// locking modal with overlay and showing loading spinner
			Tools.replaceClass(this._loadingModalOverlay, 'hidden', 'visible');

			const options = document.querySelectorAll('#webInterfacesOptions input[name="activeInterfaces"]');

			const chosenInterfaces = Array.from(options)
				.filter((option) => option.checked)
				.map((option) => option.value);
			const payload = JSON.stringify({
				serving_interfaces: chosenInterfaces,
				web_id: this.webId,
			});

			api
				.POST('/app/api/webs/serving-interface', payload)
				.then(() => {
					Tools.replaceClass(this._loadingModalOverlay, 'visible', 'hidden');
					this._modal.close();
					location.reload();
				})
				.catch((error) => {
					console.error(error);
					Tools.replaceClass(this._loadingModalOverlay, 'hidden', 'visible');
				});
		});

		Tools.appendChilds(this._modalWrap, this._title, this._content, buttonsWrapper, this._loadingModalOverlay);

		this._modal = new ModalWindow();

		this._modal.setOnCloseFunc(() => {
			Tools.removeElement(this._modalWrap);
		});

		document.body.appendChild(this._modalWrap);
	}
}

export default WebInterfacesDialog;
